import React from 'react';

const BombIcon = ({ className = "w-6 h-6", ...props }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <circle cx="12" cy="12" r="8" fill="currentColor"/>
      <rect x="11" y="4" width="2" height="6" fill="#fbbf24" rx="1"/>
      <path d="M10 2 Q12 0 14 2 Q12 4 10 2" fill="#f59e0b"/>
      <circle cx="9" cy="10" r="1" fill="#1f2937"/>
      <circle cx="15" cy="10" r="1" fill="#1f2937"/>
      <circle cx="12" cy="14" r="0.8" fill="#1f2937"/>
    </svg>
  );
};

export default BombIcon;
